import * as btc from '@scure/btc-signer';
import bch from 'bchaddrjs';
import * as eth from 'micro-eth-signer';

import { getNetworkConfig, Network } from ':fat/core/networks';

export function isAddressValid(address: string, network: Network): boolean {
  if (network === 'eth') {
    return eth.addr.isValid(address);
  }

  const networkConfig = getNetworkConfig(network);
  if (!networkConfig) {
    return false;
  }

  try {
    const addressToCheck = network === 'bch' ? bch.toLegacyAddress(address) : address;
    const addr = btc.Address(networkConfig).decode(addressToCheck);
    return typeof addr?.type === 'string';
  } catch (err) {
    return false;
  }
}
